import React, {Component} from 'react';
import {connect} from 'react-redux';
import fscreen from 'fscreen';
import {Card, Dimmer, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import ProgressBar from '../../../common/components/progressBar';
import ReprinterLabelsModal from './modal/reprinterLabels';
import Item from './item';
import './index.scss';

let timer = null;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'restartTimerShift1': true,
      'restartTimerShift2': true,
      'restartTimerShift3': true,
      'restartTimerShift4': true,
      'missingTimeForNextShiftInSecondsToShift1': 0,
      'missingTimeForNextShiftInSecondsToShift2': 0,
      'missingTimeForNextShiftInSecondsToShift3': 0,
      'missingTimeForNextShiftInSecondsToShift4': 0,
      'initTimer': true,
      'showLoader': true,
      'isFullScreen': false,
    };

    this.handler = this.handler.bind(this);
    this.onRestartTimer = this.onRestartTimer.bind(this);
    this.setTimer = this.setTimer.bind(this);
    this.goToHome = this.goToHome.bind(this);
    this.toggleFullScreen = this.toggleFullScreen.bind(this);
  }

  componentDidMount() {
    this.props.clearShiftsData();
    this.props.deleteAllPickingLabels();
    this.props.fetchSystemParameter('PICKING_DASHBOARD_REFRESH_TIME');
    this.props.fetchSystemParameter('PICKING_DASHBOARD_ALERT_TIME');
    this.props.fetchSystemParameter('PICKING_DASHBOARD_REPRINT_TIME');
    this.props.fetchSystemParameter('PICKING_DASHBOARD_PREVIOUS_ALARM');
    this.props.fetchSystemParameter('PICKING_LABELS_TO_CUT');
    this.changeFullScreen();
    this.startTimer();
  }

  componentDidUpdate() {
    const {showLoader} = this.state;
    const {loading} = this.props;
    if (showLoader && !loading) {
      this.setState({'showLoader': false});
    }
  }

  componentWillUnmount() {
    this.stopTimer();
    this.getShorterMissingTime();
  }

  startTimer() {
    const {systemParameters} = this.props;
    const dashboardRefreshTime =
      getSystemParameterValue(
        systemParameters,
        'PICKING_DASHBOARD_REFRESH_TIME'
      ) || 300;

    this.setState({'initTimer': true});
    this.props.fetchZonesList();
    this.props.fetchNextShifts();
    this.props.fetchPickingIndicators();

    timer = setInterval(() => {
      this.props.fetchZonesList();
      this.props.fetchNextShifts();
      this.props.fetchPickingIndicators();
    }, dashboardRefreshTime * 1000);
  }

  stopTimer() {
    if (timer) {
      this.setState({'initTimer': false});
      clearInterval(timer);
    }
  }

  setTimer(code, missingTimeForNextShiftInSeconds) {
    switch (code) {
      case 1:
      default:
        this.setState({
          'missingTimeForNextShiftInSecondsToShift1':
            missingTimeForNextShiftInSeconds,
        });
        break;
      case 2:
        this.setState({
          'missingTimeForNextShiftInSecondsToShift2':
            missingTimeForNextShiftInSeconds,
        });
        break;
      case 3:
        this.setState({
          'missingTimeForNextShiftInSecondsToShift3':
            missingTimeForNextShiftInSeconds,
        });
        break;
      case 4:
        this.setState({
          'missingTimeForNextShiftInSecondsToShift4':
            missingTimeForNextShiftInSeconds,
        });
        break;
    }
  }

  checkTimer() {
    const {
      restartTimerShift1,
      restartTimerShift2,
      restartTimerShift3,
      restartTimerShift4,
      initTimer,
    } = this.state;
    if (
      restartTimerShift1 &&
      restartTimerShift2 &&
      restartTimerShift3 &&
      restartTimerShift4
    ) {
      if (!initTimer) {
        this.props.clearShiftsData();
        this.startTimer();
      }
      return;
    }
    this.stopTimer();
  }

  onRestartTimer(code, restartTimer) {
    switch (code) {
      case 1:
      default:
        this.setState({'restartTimerShift1': restartTimer});
        break;
      case 2:
        this.setState({'restartTimerShift2': restartTimer});
        break;
      case 3:
        this.setState({'restartTimerShift3': restartTimer});
        break;
      case 4:
        this.setState({'restartTimerShift4': restartTimer});
        break;
    }
    this.checkTimer();
  }

  goToHome() {
    this.props.navigateTo(paths.Home);
  }

  handler() {
    if (!fscreen.fullscreenElement) {
      this.setState({'isFullScreen': false});
    }
  }

  changeFullScreen() {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', this.handler, false);
    }
  }

  getShorterMissingTime() {
    const {
      missingTimeForNextShiftInSecondsToShift1,
      missingTimeForNextShiftInSecondsToShift2,
      missingTimeForNextShiftInSecondsToShift3,
      missingTimeForNextShiftInSecondsToShift4,
    } = this.state;

    const shorterMissingTime = Math.min(
      missingTimeForNextShiftInSecondsToShift1,
      missingTimeForNextShiftInSecondsToShift2,
      missingTimeForNextShiftInSecondsToShift3,
      missingTimeForNextShiftInSecondsToShift4
    );

    this.props.onShorterMissingTime(shorterMissingTime);
  }

  toggleFullScreen() {
    if (!fscreen.fullscreenElement) {
      fscreen.requestFullscreen(document.documentElement);
      this.setState({'isFullScreen': true});
    } else {
      fscreen.exitFullscreen();
      this.setState({'isFullScreen': false});
    }
  }

  renderLoader() {
    if (this.props.loading && this.state.showLoader) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Actualizando' />
        </Dimmer>
      );
    }
    return null;
  }

  renderShift() {
    const {nextShifts} = this.props;
    return nextShifts.map((element, index) => {
      return (
        <Item
          key={index}
          shiftData={element}
          restartTimer={this.onRestartTimer}
          setMissingTimeForNextShift={this.setTimer}
        />
      );
    });
  }

  render() {
    const {indicators} = this.props;
    const icon = this.state.isFullScreen ? 'compress' : 'expand';
    return (
      <div className='picking-dashboard'>
        <div className='title-bar'>
          <div className='title'>
            <Icon
              link
              name='home'
              color='red'
              size='big'
              onClick={this.goToHome}
            />
            <Icon
              link
              name={icon}
              color='black'
              size='big'
              onClick={this.toggleFullScreen}
            />
            <ReprinterLabelsModal
              trigger={<Icon link name='print' color='red' size='big' />}
            />
            <h2>Warehouse Denied: {indicators.warehouseDenials || 0}</h2>
            <div className='title-bar-actions'>
              <ProgressBar
                label='Pedidos'
                partialQuantity={indicators.printedLabels}
                totalQuantity={indicators.dayOrders}
              />
            </div>
          </div>
        </div>

        <Card.Group itemsPerRow={2}>
          {this.renderShift()}
          {this.renderLoader()}
        </Card.Group>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'systemParameters': state.parameters.list,
    'loading': state.pickingDashboard.loadingNextShifts,
    'nextShifts': state.pickingDashboard.nextShifts,
    'indicators': state.pickingDashboard.indicators,
  };
};

const {
  clearShiftsData,
  deleteAllPickingLabels,
  fetchSystemParameter,
  fetchZonesList,
  fetchNextShifts,
  fetchPickingIndicators,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  clearShiftsData,
  deleteAllPickingLabels,
  fetchSystemParameter,
  fetchZonesList,
  fetchNextShifts,
  fetchPickingIndicators,
  navigateTo,
})(Dashboard);
